import { render, staticRenderFns } from "./UserClassifieds.vue?vue&type=template&id=4fde3d2d&scoped=true&"
import script from "./UserClassifieds.vue?vue&type=script&lang=js&"
export * from "./UserClassifieds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde3d2d",
  null
  
)

export default component.exports